var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',{staticClass:"button-style",attrs:{"round":"","hairline":"","block":"","type":"info","color":"#d1b06f"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }